import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useLoader, usePopup, useToast } from '../../../hooks';
import logo from '../../../assets/logo.png';
import { Loading, Popup, Snackbar } from '../..';
import { Container, Content } from './styles';

type Props = {
    children: React.ReactNode;
}

const AuthLayout: React.FC<Props> = ({ children }) => {
    const { pathname } = useLocation();
    const { loading } = useLoader();
    const { toast } = useToast();
    const { popup } = usePopup();

    return (
        <>
            {loading && (
                <Loading loading={loading} />
            )}
            {toast && (
                <Snackbar
                    layout="auth"
                    {...toast}
                />
            )}
            {popup && (
                <Popup { ...popup } />
            )}
            <Container>

                <div>
                    <img src={logo} alt="Flix Media Ticketx" />
                    <Content>
                        {children}
                    </Content>
                </div>
                {pathname === '/' && (
                    <span>
                        Esqueceu sua senha?
                        <Link to="/recover-password" replace>Clique aqui</Link>
                    </span>
                )}
                {pathname === '/recover-password' && (
                    <span>
                        Retornar ao login?
                        <Link to="/" replace>Clique aqui</Link>
                    </span>
                )}
            </Container>
        </>
    );
};

export { AuthLayout };
